module.exports = __webpack_public_path__ + "img/1.c253e95a.png";